module.exports = __webpack_public_path__ + "img/icon-14.47bf7301.png";